import React, {useEffect, useState} from "react";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import CustomDialog from "../../../Utils/Dialogs/CustomDialog";
import Form from "react-bootstrap/Form";
import Label from "../../../Utils/FormInputs/Label";
import {CustomInput} from "../../CustomInput";


export const useAddUnit = (actions) =>{
    const [unit_name, setName] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [openDialog, setOpenDialog] = useState(false);
    const [unit, setUnit] = useState({});
    const [unit_id, setUnitId] = useState('')
    const [openUnit, setOpenUnit] = useState(false)



    useEffect(() => {
        if(!unit){
            // setName('')
            return
        }
        setName(unit.name)
    }, [unit]);



    const handleOpenDialog = () =>{
        setOpenDialog(true)
    }

    const handleCloseDialog = () =>{
        setOpenDialog(false)
    }

    const handleOpenEdit = (_id) =>{
        setUnitId(_id)
        setOpenUnit(true)
        const formData = new FormData();
        formData.append('unit_id', _id);
        axios.post(`${config.smsUrl}/cpharmacy/unit_form`, formData).then((res) => {
            const data = res.data;
            const dt = !data ? {} : data;
            setUnit(dt);
        }).catch(err => {
            logoutErrorMessage(err, null,actions)
        })

    }

    const handleCloseEdit = () =>{
        setOpenUnit(false)
        setUnitId('')
        setName('')
    }

    const handleSubmit = (event) =>{
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const fieldValues = Object.fromEntries(formData.entries())
        if (unit_id){
            formData.append('unit', unit_id);
        }
        setSubmitted(true);
        if(fieldValues['name']){
            setIsSubmitted('pending');
            const url = unit_id ? 'edit_unit' : 'add_unit'
            axios.post(`${config.smsUrl}/cpharmacy/${url}`, formData).then(()=>{
                actions.snackbarActions.snackSuccess('Unit added successfully')
                // setLoading(true);
                setIsSubmitted('resolved');
                setSubmitted(false)
                setName("");
                setOpenDialog(false)
                setOpenUnit(false)
            }).catch(err=>{
                setIsSubmitted('rejected');
                errorMessages(err,null, actions)
            })
        }
    };

    const isPending = isSubmitted === 'pending'
    const isResolved = isSubmitted === 'resolved'

    const open = unit_id ? openUnit : openDialog
    const handleClose = unit_id ? handleCloseEdit : handleCloseDialog

    const title = unit_id ? 'Edit Unit' : 'Add Unit'

   return {
        isResolved,
       open,
       handleOpenEdit,
       handleOpenDialog,
       renderAddUnit: (
           <CustomDialog open={open} handleClose={handleClose} title={title}>
               <form onSubmit={handleSubmit} autoComplete='off'>
                   <Form.Group>
                       <Label type name='Unit' htmlFor="name"/>
                       <CustomInput name='name' isRequired submitted={submitted} inputValue={unit_name} type='text' placeholder='Enter unit name' reset={isResolved}/>
                   </Form.Group>
                   <button type='submit' id="save_unit"  className='btn btn-sm sms-btn mr-4'>{isPending ? 'Saving...' :'Save'}</button>
               </form>
           </CustomDialog>
       )

   }



}